import { defineSlotRecipe } from "@pandacss/dev";

export const slots = [
  "root",
  "row",
  "footer",
  "leftColumn",
  "labelContainer",
  "rightColumn",
] as const;

export const aromaMinitable = defineSlotRecipe({
  className: "aroma-minitable",
  jsx: ["Minitable"],
  slots,
  base: {
    root: {
      borderWidth: "m",
      borderRadius: "l",
      borderColor: "border.neutral.subtle",
      width: "100%",
    },
    row: {
      borderTopLeftRadius: { base: 0, _first: "l" },
      borderTopRightRadius: { base: 0, _first: "l" },
      borderBottomLeftRadius: { base: 0, _last: "l" },
      borderBottomRightRadius: { base: 0, _last: "l" },
      alignItems: "center",
      gap: "gap.4",
      flexDirection: "row",
      justifyContent: "space-between",
      minHeight: "2xl",
      padding: "padding.3",
      borderColor: "border.neutral.subtle",
      borderBottomWidth: { base: "m", _last: 0 },
    },
    footer: {
      borderBottomLeftRadius: "l",
      borderBottomRightRadius: "l",
      alignItems: "center",
      gap: "gap.4",
      flexDirection: "row",
      justifyContent: "space-between",
      minHeight: "2xl",
      padding: "padding.3",
      borderColor: "border.neutral.subtle",
      borderBottomWidth: { base: "m", _last: 0 },
      background: "background.neutral.base.subtler",
    },
    leftColumn: {
      alignItems: "center",
      gap: "gap.2",
      flexDirection: "row",
    },
    rightColumn: {
      alignItems: "center",
      gap: "gap.2",
      flexDirection: "row",
    },
    labelContainer: {
      gap: "gap.0",
      flexDirection: "column",
    },
  },
  variants: {
    stacked: {
      true: {
        row: {
          alignItems: "start",
          gap: "gap.1",
          flexDirection: "column",
          "&[data-has-secondary-description]": {
            flexDirection: "row",
          },
        },
        rightColumn: {
          flexDirection: "column",
          alignItems: "start",
          gap: "gap.0",
          "&[data-has-secondary-description]": {
            alignItems: "end",
          },
        },
      },
    },
  },
});
